/* Align each detail line to the tallest matching line within its visible grid row. */
(() => {
  const main = document.querySelector('#MainContent');
  if (!main) return;
  let queued = false;
  const slots = ['title', 'vendor', 'swatches', 'price', 'offer'];
  function alignRows() {
    queued = false;
    const cards = Array.from(main.querySelectorAll('.ulg-aligned-card'))
      .filter(card => card.getBoundingClientRect().width > 0);
    // Reset before measuring so titles are never cropped, including after resizing.
    cards.forEach(card => slots.forEach(slot => {
      const line = card.querySelector('.ulg-card-line--' + slot);
      if (line) line.style.minHeight = '';
    }));
    const rows = new Map();
    cards.forEach(card => {
      const cell = card.closest('.grid-item');
      const rect = (cell || card).getBoundingClientRect();
      const key = Math.round(rect.top + window.scrollY);
      if (!rows.has(key)) rows.set(key, []);
      rows.get(key).push(card);
    });
    rows.forEach(row => slots.forEach(slot => {
      const lines = row.map(card => card.querySelector('.ulg-card-line--' + slot)).filter(Boolean);
      const height = Math.max(0, ...lines.map(line => line.getBoundingClientRect().height));
      lines.forEach(line => { line.style.minHeight = Math.ceil(height) + 'px'; });
    }));
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(alignRows);
  }
  new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.fonts?.ready.then(schedule);
  // Grid/list switches change existing element classes without replacing cards.
  main.addEventListener('click', schedule);
  schedule();
})();
